import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import RssFeedRoundedIcon from "@mui/icons-material/RssFeedRounded";
import {
  Box,
  InputAdornment,
  OutlinedInput,
  Chip,
  IconButton,
  FormControl,
} from "@mui/material";
export function Search() {
  return (
    <FormControl sx={{ width: { xs: "100%", md: "25ch" } }} variant="outlined">
      <OutlinedInput
        size="small"
        id="search"
        placeholder="Search…"
        sx={{ flexGrow: 1 }}
        startAdornment={
          <InputAdornment position="start" sx={{ color: "text.primary" }}>
            <SearchRoundedIcon fontSize="small" />
          </InputAdornment>
        }
        inputProps={{
          "aria-label": "search",
        }}
      />
    </FormControl>
  );
}

const Filter = ({ handleClick, tags }) => {
  return (
    <div className="my-4">
      <Box
        sx={{
          display: { xs: "flex", sm: "none" },
          flexDirection: "row",
          gap: 1,
          width: { xs: "100%", md: "fit-content" },
          overflow: "auto",
        }}
      >
        <Search />
        <IconButton size="small" aria-label="RSS feed">
          <RssFeedRoundedIcon />
        </IconButton>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column-reverse", md: "row" },
          width: "100%",
          justifyContent: "space-between",
          alignItems: { xs: "start", md: "center" },
          gap: 4,
          margin: "20px 0",
          // overflow: "auto",
        }}
      >
        <Box
          sx={{
            display: "flex", // changed from "inline-flex"
            flexDirection: "row",
            flexWrap: "wrap", // allow wrapping
            gap: { sm: 3, xs: 1 },
          }}
        >
          <Chip
            onClick={handleClick.bind(null, "All")}
            size="medium"
            label="All categories"
          />

          {tags.map((tag) => (
            <Chip
              onClick={handleClick.bind(null, tag)}
              size="medium"
              label={tag}
              sx={{
                backgroundColor: "transparent",
                border: "none",
              }}
            />
          ))}
        </Box>
        <Box
          sx={{
            display: { xs: "none", sm: "flex" },
            flexDirection: "row",
            gap: 1,
            width: { xs: "100%", md: "fit-content" },
            overflow: "auto",
          }}
        >
          <Search />
          <IconButton size="small" aria-label="RSS feed">
            <RssFeedRoundedIcon />
          </IconButton>
        </Box>
      </Box>
    </div>
  );
};

export default Filter;
